import { CUSTOM_GROUPING_ACTION_TYPES } from '@constants/actionTypes/customGroupingActionTypes';

// Initial state typed to match the CustomGroupingState interface
export const INITIAL_STATE = {
};

interface CustomGroupingAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: CustomGroupingAction) => {
    switch (action?.type) {
        case CUSTOM_GROUPING_ACTION_TYPES.SET_CUSTOM_GROUPING:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
